import smoothscroll from "smoothscroll-polyfill";

smoothscroll.polyfill();

document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
  anchor.addEventListener("click", (e) => {
    e.preventDefault();

    const href = anchor.getAttribute("href");
    if (href) {
      const el = document.querySelector(href);

      if (el) {
        const headerOffset = window.innerWidth < 1024 ? 90 : 200;
        // getBoundingClientRect() is relative to the viewport, window.scrollTo()
        // expects a document position, so the current scroll offset has to be
        // added - otherwise the target is off by the current scroll position and
        // clamps to the top of the page as soon as it turns negative.
        const elementPosition =
          el.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    }
  });
});
